<template>
  <div class="ActiveTab ProcessInfoTab">
    <LocatieInformatieHeader :chargingpoint="chargingpoint">
      <h4>{{ $t(`${translationPath}.title`) }}</h4>
    </LocatieInformatieHeader>
    <div class="ActiveTab__Content">
      <b-spinner
        v-if="isLoading"
        small
        variant="secondary"
        class="ml-2"
      />
      <div v-else>
        <div v-if="isInProcess">
          <p>
            <strong>{{ $t(`${translationPath}.caseRef`) }}</strong><br>
            <a
              v-if="processUrl"
              :href="processUrl"
              target="_blank"
              title="Ga naar het Workflowproces"
            >
              <b-icon-box-arrow-up-right class="mr-1" />
              {{ caseRef }}
            </a>
            <span v-else> {{ caseRef }}</span>
            <span
              v-if="isWorkflowAltLocation"
              class="ml-1"
            >
              (Alternatieve locatie)
            </span>
          </p>
          <div v-if="notFound">
            {{ $t(`${translationPath}.processNotFound`) }}
          </div>
          <div v-else>
            <strong> {{ $t(`${translationPath}.status.current`) }} </strong> <br>
            {{ $t(`${translationPath}.status.${processStatus}`) }}
          </div>
        </div>
        <div v-else>
          <span> {{ $t(`${translationPath}.notLinked`) }}</span>
          <CreateWorkflowProcess @setAlert="handleAlert" />
        </div>
        <b-alert
          :show="alertDismissSec"
          dismissible
          fade
          :class="['mt-3', alertVariant]"
          @dismiss-count-down="countDownChanged"
        >
          {{ responseAlertMessage }}
        </b-alert>
      </div>
    </div>
  </div>
</template>

<script>
import chargingpointDataMixin from '@/mixins/chargingpoint/chargingpointDataMixin'
import LocatieInformatieHeader from '@/components/map/sidebar/LocatieInformatieHeader'
import CreateWorkflowProcess from '@/components/map/sidebar/Tabs/CreateWorkflowProcess'
import { BIconBoxArrowUpRight } from 'bootstrap-vue'

export default {
  name: 'ProcessInfoTab',
  components: { LocatieInformatieHeader, CreateWorkflowProcess, BIconBoxArrowUpRight },
  mixins: [chargingpointDataMixin],
  data () {
    return {
      translationPath: 'components.sidebar.Tabs.ProcessInfoTab',
      alertVariant: 'alert-success',
      alertDismissSec: 0,
      responseAlertMessage: '',
      processUrl: '',
      processStatus: '',
      isLoading: false,
      notFound: false,
    }
  },
  computed: {
    externalProcessId(){
      return this.chargingpoint?.externalProcessId
    },
    workflowCaseRef(){
      return this.chargingpoint?.workflowCaseRef
    },
    isInProcess() {
      return (
        !!this.chargingpoint?.workflowCaseRef ||
        !!this.chargingpoint?.externalProcessId
      )
    },
    caseRef() {
      return (
        this.chargingpoint?.workflowCaseRef ||
        this.chargingpoint?.externalProcessId
      )
    },
    workflowUuid () {
      return this.chargingpoint.workflowUuid
    },
    isWorkflowAltLocation () {
      return this.chargingpoint.isWorkflowAltLocation
    },
    isRealized () {
      return this.chargingpoint.properties.status.includes('realized') // all status types //
    },
  },
  watch: {
    chargingpoint: {
      deep: true,
      immediate: true,
      handler (point) {
        if (point?.workflowUuid || point.workflowCaseRef) {
          this.fetchProcess()
        } else if (this.externalProcessId) {
          this.processStatus = this.isRealized ? 'completed': 'active'
        }
      },
    },
  },
  methods: {
    async fetchProcess () {
      this.isLoading = true
      const token = await this.$auth.getTokenSilently()
      const api = await fetch('/api/get-workflow-process', {
        method: 'POST',
        headers: {
          authorization: 'Bearer ' + token,
        },
        body: JSON.stringify({ uuid: this.workflowUuid, caseRef: this.workflowCaseRef }),
      })

      if (!api.ok) {
        this.notFound = api.status === 404
        this.isLoading = false
        return this.processUrl = this.processStatus = ''
      }

      const response = await api.json()

      const routeType = response.processType.routeType
      this.processUrl = `${response.baseUrl}${routeType}/${response.uuid}`
      this.processStatus = response?.processStatus?.status
      this.isLoading = false
      this.notFound = false
    },
    countDownChanged (dismissAlertCount) {
      this.alertDismissSec = dismissAlertCount
    },
    handleAlert (event) {
      this.alertDismissSec = event.message ? 10 : 4
      this.alertVariant = `alert-${event.type}`
      this.responseAlertMessage = event.message || this.$i18n.t(`${this.translationPath}.responseAlertMessage`)
    },
  },
}
</script>

